import Vue from 'vue'
import Router from 'vue-router'
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: () => import('../views/iframepage/Iframepage.vue'),
      redirect: 'home',
      children: [
        // 首页
        {
          path: 'home',
          component: () => import('../views/Home/Home.vue'),
          meta: {
            routerJumpStyle: 0
          }
        },
        // 媒体关注和专题报道
        {
          path: 'newsfeed',
          component: () => import('../views/Newsfeed/Newsfeed.vue'),
          meta: {
            routerJumpStyle: 0,
          }
        },
        // 工作动态(项目动态公司要闻)
        {
          path: 'projectgroup',
          component: () => import('../views/Newsfeed/Projectgroup.vue')
        },
        // 经营发展(主营业务和旗下业务)
        {
          path: 'expand',
          component: () => import('../views/expand/Expand.vue')
        },
        // 发展规划
        {
          path: 'development',
          component: () => import('../views/expand/Development.vue')
        },
        // 企业理念
        {
          path: 'cultureidea',
          component: () => import('../views/culture/Cultureidea.vue')
        },
        // 员工风采
        {
          path: 'culturepeople',
          component: () => import('../views/culture/Culturepeople.vue')
        },
        // 培训提升
        {
          path: 'cultureup',
          component: () => import('../views/culture/Cultureup.vue')
        },
        // 党风廉政
        {
          path: 'partystyle',
          component: () => import('../views/party/Partystyle.vue')
        },
        // 专题学习
        {
          path: 'partystudy',
          component: () => import('../views/party/Partystudy.vue')
        },
        // 政治理论
        {
          path: 'partytheory',
          component: () => import('../views/party/Partytheory.vue')
        },
        // 人事任免
        {
          path: 'appointment',
          component: () => import('../views/personnel/Appointment.vue')
        },
        // 诚聘精英
        {
          path: 'recruit',
          component: () => import('../views/personnel/Recruit.vue')
        },
        //公司简介
        {
          path: 'synopsis',
          component: () => import('../views/aboutus/Synopsis.vue')
        },
        // 组织机构
        {
          path: 'organization',
          component: () => import('../views/aboutus/Organization.vue')
        },
        // 领导致辞
        {
          path: 'leadertalk',
          component: () => import('../views/aboutus/Leadertalk.vue')
        },
        // 联系方式
        {
          path: 'contact',
          component: () => import('../views/contact/Contact.vue')
        },
        {
          path: 'detail',
          component: () => import('../views/detail/detail.vue')
        },
        // 主营业务及旗下业务子菜单(expand)详情
        {
          path: 'exdetail',
          component: () => import('../views/exdetail/exdetail.vue')
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js